var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrenchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wrench-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.996,
    viewBox: "0 0 18 17.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12776",
    "data-name": "Path 12776",
    d: "M2.988,16.324l7.268-7.268a5.257,5.257,0,0,1,7.257-5.942l.759.334L15.225,6.5l1.6,1.6L19.87,5.051,20.2,5.8a5.251,5.251,0,0,1-5.943,7.257L6.994,20.329a1.133,1.133,0,0,1-1.6,0l-2.4-2.4a1.133,1.133,0,0,1,0-1.6ZM6.195,19.53,13.922,11.8l.323.091a4.131,4.131,0,0,0,5.189-4.8L16.822,9.7,13.616,6.49l2.612-2.606a4.118,4.118,0,0,0-4.8,5.189l.091.323L3.787,17.129Z",
    transform: "translate(-2.656 -2.666)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 0.736,
    cy: 0.736,
    r: 0.736,
    transform: "translate(3.76 15.256) rotate(-135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchLine);
export default __webpack_public_path__ + "static/media/wrench-line.d81ad61d5e9454e6bbfc369bfac47880.svg";
export { ForwardRef as ReactComponent };